export const BREAKPOINTS = {
  MEDIUM: '@media (max-width: 800px)',
  SMALL: '@media (max-width: 420px)',
  TINY: '@media (max-width: 340px)'
}

export const HOUR_COLOR_COMBINATION = {
  0: ['hsl(233, 67%, 18%)', 'hsl(218, 46%, 10%)'],
  1: ['hsl(233, 67%, 14%)', 'hsl(218, 46%, 14%)'],
  2: ['hsl(220, 67%, 8%)', 'hsl(228, 56%, 18%)'],
  3: ['hsl(218, 46%, 8%)', 'hsl(233, 67%, 22%)'],
  4: ['hsl(217, 72%, 10%)', 'hsl(200, 33%, 18%)'],
  5: ['hsl(217, 72%, 16%)', 'hsl(184, 33%, 40%)'],
  6: ['hsl(218, 82%, 28%)', 'hsl(31, 70%, 54%)'],
  7: ['hsl(218, 82%, 34%)', 'hsl(31, 73%, 56%)'],
  8: ['hsl(244, 63%, 47%)', 'hsl(32, 75%, 57%)'],
  9: ['hsl(244, 62%, 49%)', 'hsl(33, 75%, 57%)'],
  10: ['hsl(244, 62%, 51%)', 'hsl(32, 75%, 54%)'],
  11: ['hsl(219, 77%, 49%)', 'hsl(33, 75%, 54%)'],
  12: ['hsl(216, 76%, 50%)', 'hsl(33, 80%, 54%)'],
  13: ['hsl(212, 78%, 50%)', 'hsl(34, 80%, 54%)'],
  14: ['hsl(212, 74%, 50%)', 'hsl(33, 80%, 54%)'],
  15: ['hsl(214, 74%, 46%)', 'hsl(31, 75%, 54%)'],
  16: ['hsl(216, 72%, 46%)', 'hsl(32, 70%, 54%)'],
  17: ['hsl(219, 72%, 45%)', ' hsl(31, 69%, 55%)'],
  18: ['hsl(210, 50%, 50%)', 'hsl(339, 25%, 60%)'],
  19: ['hsl(210, 50%, 45%)', 'hsl(339, 20%, 55%)'],
  20: ['hsl(218, 76%, 35%)', 'hsl(25, 60%, 55%)'],
  21: ['hsl(218, 82%, 27%)', 'hsl(23, 40%, 40%)'],
  22: ['hsl(225, 70%, 27%)', 'hsl(218, 80%, 12%)'],
  23: ['hsl(233, 57%, 22%)', 'hsl(218, 70%, 12%)']
}
